import { render, staticRenderFns } from "./search_A.vue?vue&type=template&id=b67d80b0&scoped=true&"
import script from "./search_A.vue?vue&type=script&lang=js&"
export * from "./search_A.vue?vue&type=script&lang=js&"
import style0 from "./search_A.vue?vue&type=style&index=0&id=b67d80b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67d80b0",
  null
  
)

export default component.exports